export const LAYOUT_STYLE_VALUES = {
  SQUARE: 1,
  ROUND: 2,
};



// WEBPACK FOOTER //
// ./~/wix-vod-shared/src/app-settings/constants/layout-style-values.js